import React from 'react';
import { withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import cx from 'classnames';

import { AuthRoute, Loading } from 'moovila-common';

import GlobalMessageBox from './GlobalMessageBox';
import GlobalQuestionBox from './GlobalQuestionBox';
import globalImpersonate from './globalImpersonate';
import Login from './Login';
import Home from './Home';
import Admin from '../containers/Admin';
import Reports from '../containers/Reports';
import Utilities from '../containers/Utilities';
import LoginRedirect from '../containers/LoginRedirect';

import { logout, resetLoading } from '../actions';

import './MOM.css';

const MOM = ({location, logout, resetLoading, setupGlobalImpersonation}) => {
  window.masterLogout = () => {
    logout();
    resetLoading();
  };
  const p = location.pathname;
  const momClass = cx({
    'MOM': true,
    'site-wrapper': p === '/login' || p === '/home' || p === '/',
    'site-wrapper--home': p === '/home',
  });
  return (
    <div className={momClass}>
      <div className='page-wrapper'>
        <Switch>
          <AuthRoute path="/home" component={Home} />
          <AuthRoute path="/admin" RenderComponent={Admin} setupGlobalImpersonation={setupGlobalImpersonation} />
          <AuthRoute path="/reports" component={Reports} />
          <AuthRoute path="/utilities" component={Utilities} />
          <AuthRoute path="/login" component={Login} isPublic={true} />
          <Route path="/" component={LoginRedirect} />
        </Switch>
        <Loading />
      </div>
      <footer className='enterprise-footer'>
        <div className='inner'>
          Copyright &copy; { new Date().getFullYear() } Moovila, Inc. All rights reserved.
        </div>
      </footer>
      <GlobalMessageBox />
      <GlobalQuestionBox />
    </div>
  );
};

export default withRouter(connect(s => s, {
  logout,
  resetLoading,
})(globalImpersonate(MOM)));



// WEBPACK FOOTER //
// ./src/components/MOM.js